import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RolesService } from 'src/app/services/roles-service/roles.service';

@Component({
  selector: 'app-roles-roles-breadcrumb-card',
  templateUrl: './roles-roles-breadcrumb-card.component.html',
  styleUrls: ['./roles-roles-breadcrumb-card.component.scss']
})
export class RolesRolesBreadcrumbCardComponent implements OnInit {

  constructor(private router: Router,
              private rolesService: RolesService) { }

  ngOnInit() { }

  public createRole() {
    this.router.navigate(['/account/role']);
  }

  public search(event) {
    this.rolesService.searchRoles(event.target.value);
  }

}
